import { useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DataTable } from "./DataTable";
import { useNavModel } from "@/model/navModel";
import { summaryModel } from "./summaryModel";
import { DetailActionTypeEnum, useDetailModel } from "../customerDetail/detailModel";

export const DataBox = () => {

    const { addNav } = useNavModel();
    const {
        selectedRowKeys,
        setSelectedData, selectedData,
        setInitAccountVisible,
        setDetailPartner
    } = summaryModel();

    const { setCustomerCode, setTitle, setActionType } = useDetailModel();

    const onDetail = () => {
        if (selectedRowKeys && selectedRowKeys.length > 1) {
            message.error("请选择单条记录!");
            return
        }
        if (selectedRowKeys && selectedRowKeys.length === 1) {
            if (selectedData) {
                setCustomerCode(selectedData[0].partnerCode);
                setTitle(selectedData[0].partnerName);
            }
            setDetailPartner(selectedData[0]?.partnerCode ?? "");
            setActionType(DetailActionTypeEnum.ACCOUNT)
            addNav("16-2-1");
        } else {
            message.error("请选择记录!");
        }
    }

    const onInitAccount = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setInitAccountVisible(true);
        } else {
            message.error("请选择记录!");
        }
    }

    const action = (
        <>
            <div>
            <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onDetail}
                >查看</Button>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onInitAccount}
                >账户初始化</Button>
            </div>
        </>
    );

    return (
        <YhBox title={action}>
            <DataTable />
        </YhBox>
    )
}
